import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Header from 'reservations/base/components/Header';
import {
  getLocationListHeaderBrandStyles,
  getLocationListTextBrandStyles
} from 'reservations/brand/helpers/v2/styles';

interface LocationListTopMatterProps {
  restaurantName: string;
}

const LocationListTopMatter = ({
  restaurantName
}: LocationListTopMatterProps) => {
  return (
    <Grid container direction="column">
      <Grid item sx={theme => getLocationListHeaderBrandStyles(theme)}>
        <Header text={restaurantName} />
      </Grid>
      <Grid item>
        <Typography sx={theme => getLocationListTextBrandStyles(theme)}>
          Select a location
        </Typography>
      </Grid>
    </Grid>
  );
};

export default LocationListTopMatter;
